var _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29688 1.72159H11.4531L14.1094 4.33759V14.2784H4.29688V1.72159Z",
    stroke: "#222627",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9219 1.92044V4.68747H13.8594",
    stroke: "#222627",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.89062,
    y: 5.10794,
    width: 7,
    height: 7.625,
    rx: 1,
    fill: "#F34343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02197 9.4357V10.6222H4.29688V7.21866H5.46802C6.3147 7.21866 6.73804 7.57755 6.73804 8.29532C6.73804 8.64395 6.60986 8.92374 6.35352 9.13467C6.09863 9.34415 5.7793 9.44449 5.39551 9.4357H5.02197ZM5.02197 7.78116V8.87979H5.33618C5.76245 8.87979 5.97559 8.69449 5.97559 8.32388C5.97559 7.96207 5.76465 7.78116 5.34277 7.78116H5.02197Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.152afe933e0acd1fd3d8b4073f72d6d9.svg";
export { ForwardRef as ReactComponent };